module.exports = __webpack_public_path__ + "img/rndt_sens.ea09a89b.png";